<template>
    <div>      
      <div class="wrap" ref="wrap">          
        <transition name="router-animation">
          <router-view :key="$route.fullPath"/>          
        </transition>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Start',
  //components: { Sidebar, Header, Chat, Helper },  
  methods: {
    
  },
  computed: {
    
  },
  created() {
    //console.log(`i am in start created`);    
  },
};
</script>